import { storage } from 'utils/storage';

/**
 * Redirects to microsoft logout page to ensure user is logged out
 */
export function logout() {
  storage.setJwt('');
  window.location = 'https://login.microsoftonline.com/common/oauth2/logout';
}
